import store from "@/store";

export default function checkAdmin(to, from, next) {
  if (store.getters.isLoggedin) {
    const user = store.getters.getUser;
    if (user.admin) next();
    else {
      store.commit("sendMessage", {
        text: "Você não pode acessar este conteúdo",
        color: "red"
      });
      next("/");
    }
  } else {
    next("/login");
  }
}
